import React from "react";

export interface TickMarkProps {
  width?: number;
  height?: number;
  color?: string;
}

const TickMark: React.FC<TickMarkProps> = ({ width = 16, height = 16, color = "#ffffff" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 7.5L5.7 11.5L15.5 1.5" stroke={color} stroke-width="3" stroke-linecap="round" />
    </svg>
  );
};

export default TickMark;
